// ============================================
// Home Store (Zustand)
// 홈 탭 상태 관리
// ============================================

import { createStore } from 'zustand/vanilla';

export const useHomeStore = createStore((set, get) => ({
  // ============================================
  // State
  // ============================================

  // 선택된 콘텐츠 (상세 모달용)
  selectedContentForDetail: null,

  // 좋아요 처리 중
  isLikeProcessing: false,

  // 현재 카테고리 필터
  homeCategoryFilter: 'character',

  // 발행된 콘텐츠 캐시
  publishedContentCache: {
    character: [],
    ranking: []
  },

  // 더 불러올 콘텐츠 있는지
  hasMoreContentCache: {
    character: true,
    ranking: true
  },

  // 마지막 문서 (페이지네이션)
  lastPublishedDocCache: {
    character: null,
    ranking: null
  },

  // 로딩 중
  isLoadingMore: false,

  // 랭킹 기간 필터 ('daily' | 'weekly' | 'allTime')
  rankingPeriod: 'daily',

  // Firestore 인스턴스
  db: null,

  // ============================================
  // Actions
  // ============================================

  setSelectedContent: (content) => set({ selectedContentForDetail: content }),

  setIsLikeProcessing: (val) => set({ isLikeProcessing: val }),

  setHomeCategoryFilter: (category) => set({ homeCategoryFilter: category }),

  setIsLoadingMore: (val) => set({ isLoadingMore: val }),

  setRankingPeriod: (period) => set({ rankingPeriod: period }),

  setDb: (db) => set({ db }),

  getDb: () => {
    let db = get().db;
    if (!db) {
      db = firebase.firestore();
      set({ db });
    }
    return db;
  },

  setPublishedContentCache: (cache) => set({ publishedContentCache: cache }),

  updateCacheForType: (type, items) => set((state) => ({
    publishedContentCache: {
      ...state.publishedContentCache,
      [type]: items
    }
  })),

  appendCacheForType: (type, items) => set((state) => ({
    publishedContentCache: {
      ...state.publishedContentCache,
      [type]: [...state.publishedContentCache[type], ...items]
    }
  })),

  setHasMoreForType: (type, hasMore) => set((state) => ({
    hasMoreContentCache: {
      ...state.hasMoreContentCache,
      [type]: hasMore
    }
  })),

  setLastDocForType: (type, doc) => set((state) => ({
    lastPublishedDocCache: {
      ...state.lastPublishedDocCache,
      [type]: doc
    }
  })),

  resetCacheForType: (type) => set((state) => ({
    publishedContentCache: {
      ...state.publishedContentCache,
      [type]: []
    },
    hasMoreContentCache: {
      ...state.hasMoreContentCache,
      [type]: true
    },
    lastPublishedDocCache: {
      ...state.lastPublishedDocCache,
      [type]: null
    }
  })),

  // ============================================
  // Reset
  // ============================================

  reset: () => set({
    selectedContentForDetail: null,
    isLikeProcessing: false,
    homeCategoryFilter: 'character',
    publishedContentCache: { character: [], ranking: [] },
    hasMoreContentCache: { character: true, ranking: true },
    lastPublishedDocCache: { character: null, ranking: null },
    isLoadingMore: false,
    rankingPeriod: 'daily'
  })
}));

export default useHomeStore;
